/**
 * SEO for the signed-in home feed (`/feed`): matches former authenticated `/` meta.
 */

import { env } from '@web/src/lib/env.client'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'

export function feedPageHeadFromLoaderData() {
  return seo({
    title: `Home | ${env.VITE_APP_NAME}`,
    description: 'Feed Page',
    robots: robotsMetaForEnvironment({ all: 'noindex,nofollow' }),
    meta: [{ name: 'rating', content: 'adult' }],
  })
}
